<template>
	<div class="resolved-btn-container">
        <app-button
            class="resolved-btn"
			:style="`border-color:${$appColors.primary};color:${state === 1 ? $appColors.white : $appColors.primary};background-color:${ state === 1 ? $appColors.primary : $appColors.white}`"
            text="Por Resolver"
            @click="change(1)"
        />
        <app-button
            class="resolved-btn"
			:style="`border-color:${$appColors.primary};color:${state === 2 ? $appColors.white : $appColors.primary};background-color:${ state === 2 ? $appColors.primary : $appColors.white}`"
            text="Resueltos"
            @click="change(2)"
        />
	</div>
</template>
<script>
import appButton from '@/components/shared/app-button';

function change(val) {
	this.$emit('input', val);
}

export default {
	name: 'polls-state-filter',
	components: {
		appButton,
	},
	methods: {
		change,
	},
	props: {
		state: {
			required: true,
			type: Number,
		},
	},
};
</script>
<style lang="scss" scoped>
.resolved-btn-container {
	align-items: center;
	display: flex;
	justify-content: flex-end;

	.resolved-btn {
		border: 1px solid;
		padding: 5px 17px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/polls/polls-state-filter.vue